import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import clsx from 'clsx';
import styles from './Text.module.css.js';
import { Base } from '../../Internal/Base/Base.js';

const defaultTag = 'span';
const allowedTags = [
    defaultTag,
    'div',
    'p',
    'label',
    's',
    'em',
    'b',
    'i',
    'dd',
    'dt',
    'small',
    'time',
    'strong',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
];
const Text = ({ type = 'body', className, as, ...props }) => (jsxRuntimeExports.jsx(Base, { as: as || defaultTag, className: clsx(styles[type], className), ...props, children: props.children }));
Text.displayName = 'Text';

export { Text, allowedTags };
//# sourceMappingURL=Text.js.map
